module.exports = __webpack_public_path__ + "img/SKMJ_map1.50460e66.jpg";